var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app",
      class: [
        _vm.isRTL ? "rtl" : "",
        _vm.isSpecialGlyphs ? "special-glyphs" : ""
      ],
      attrs: { id: "app" }
    },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("ribbon"),
      _vm._v(" "),
      _c("jhi-navbar"),
      _vm._v(" "),
      _c("Maintenance"),
      _vm._v(" "),
      _c("news"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("jhi-footer", { attrs: { id: "switch" } }),
      _vm._v(" "),
      _vm.isShowDoubleUp
        ? _c("div", { on: { click: _vm.topFunction } }, [
            _c("img", {
              attrs: {
                src: _vm.MINIO_BUCKET_ADDRESS + "/ToTop.svg",
                alt: "top"
              }
            }),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.back_to_the_top))])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showForbiddenAccessPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-data": { simpleText: _vm.$t("cloudFlarePopup") },
              hasConfirmAction: false,
              hasCancelAction: false
            },
            on: {
              "close-action": function($event) {
                _vm.showForbiddenAccessPopup = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }